import { toast } from 'react-toastify'

import { handleCallbackAction as handleCallbackActionBase } from '@domain-group/javascript-utils'
import type { HandleCallbackActionParams as HandleCallbackActionBaseParams } from '@domain-group/javascript-utils'

const toastError = (params: { message: string }) => {
  const { message } = params
  toast.warn(message)
}
export interface HandleCallbackActionParams extends HandleCallbackActionBaseParams {
  toastText: string,
}

const handleCallbackAction = (params: HandleCallbackActionParams) => {
  const {
    callbacks,
    toastText,
  } = params

  const updatedCallbacks = {
    ...callbacks,
    alertError: toastError,
    alertSuccess: toastText ? () => toast(`${toastText} Successfully`) : null,
  }

  const updatedParams = {
    ...params,
    callbacks: updatedCallbacks,
  }

  // @ts-expect-error TS2345
  return handleCallbackActionBase(updatedParams)
}

export default handleCallbackAction
